const RegularCobrandedKubitColorsFoundationsTheming = {
    color_accent_active_animation_border_50: 'rgba(10, 89, 101, 1)',
    color_accent_active_primary_border_100: 'rgba(19, 26, 35, 1)',
    color_accent_active_primary_border_50: 'rgba(19, 26, 35, 1)',
    color_accent_active_primary_border_mainsection_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_optative_bg_50: 'rgba(17, 17, 17, 1)',
    color_accent_default_optative_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_default_optative_icon_100: 'rgba(0, 110, 182, 1)',
    color_accent_default_optative_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_default_primary_bg_100: 'rgba(19, 26, 35, 1)',
    color_accent_default_primary_bg_50: 'rgba(255, 216, 20, 1)',
    color_accent_default_primary_border_100: 'rgba(255, 255, 255, 0)',
    color_accent_default_primary_border_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_primary_font_100: 'rgba(6, 113, 128, 1)',
    color_accent_default_primary_font_150: 'rgba(255, 255, 255, 1)',
    color_accent_default_primary_font_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_primary_icon_100: 'rgba(6, 113, 128, 1)',
    color_accent_default_primary_icon_150: 'rgba(6, 113, 128, 1)',
    color_accent_default_primary_icon_200: 'rgba(255, 255, 255, 1)',
    color_accent_default_primary_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_bg_100: 'rgba(255, 255, 255, 0)',
    color_accent_default_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_default_secondary_border_100: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_border_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_font_100: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_font_150: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_font_200: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_font_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_icon_100: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_icon_150: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_icon_200: 'rgba(19, 26, 35, 1)',
    color_accent_default_secondary_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_default_tertiary_bg_100: 'rgba(0, 110, 182, 1)',
    color_accent_default_tertiary_bg_50: 'rgba(0, 110, 182, 1)',
    color_accent_default_tertiary_font_100: 'rgba(255, 255, 255, 1)',
    color_accent_default_tertiary_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_default_tertiary_icon_100: 'rgba(255, 255, 255, 1)',
    color_accent_default_tertiary_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_disabled_bg_100: 'rgba(221, 229, 231, 1)',
    color_accent_disabled_bg_200: 'rgba(221, 229, 231, 1)',
    color_accent_disabled_bg_300: 'rgba(187, 202, 205, 1)',
    color_accent_disabled_bg_50: 'rgba(19, 26, 35, 1)',
    color_accent_disabled_bg_mainsection_100: 'rgba(221, 229, 231, 1)',
    color_accent_disabled_border_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_border_150: 'rgba(246, 250, 251, 1)',
    color_accent_disabled_border_50: 'rgba(95, 121, 125, 1)',
    color_accent_disabled_font_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_font_150: 'rgba(246, 250, 251, 1)',
    color_accent_disabled_font_50: 'rgba(19, 26, 35, 1)',
    color_accent_disabled_font_mainsection_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_font_mainsection_50: 'rgba(19, 26, 35, 1)',
    color_accent_disabled_icon_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_icon_150: 'rgba(246, 250, 251, 1)',
    color_accent_disabled_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_disabled_icon_mainsection_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_icon_mainsection_50: 'rgba(19, 26, 35, 1)',
    color_accent_hover_primary_bg_100: 'rgba(221, 250, 252, 1)',
    color_accent_hover_primary_bg_50: 'rgba(255, 231, 114, 1)',
    color_accent_hover_primary_font_100: 'rgba(187, 202, 205, 1)',
    color_accent_hover_primary_font_150: 'rgba(255, 255, 255, 1)',
    color_accent_hover_primary_font_50: 'rgba(19, 26, 35, 1)',
    color_accent_hover_primary_icon_100: 'rgba(96, 183, 194, 1)',
    color_accent_hover_primary_icon_150: 'rgba(96, 183, 194, 1)',
    color_accent_hover_primary_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_hover_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_hover_secondary_font_200: 'rgba(5, 56, 64, 1)',
    color_accent_hover_secondary_font_50: 'rgba(95, 121, 125, 1)',
    color_accent_hover_secondary_icon_100: 'rgba(5, 56, 64, 1)',
    color_accent_hover_secondary_icon_50: 'rgba(145, 170, 173, 1)',
    color_accent_keyboardfocus_border_100: 'rgba(209, 114, 24, 1)',
    color_accent_keyboardfocus_border_50: 'rgba(255, 255, 255, 1)',
    color_accent_loading_optative_bg_50: 'rgba(17, 17, 17, 1)',
    color_accent_loading_optative_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_loading_primary_bg_100: 'rgba(43, 49, 63, 1)',
    color_accent_loading_primary_bg_50: 'rgba(255, 216, 20, 1)',
    color_accent_loading_primary_icon_50: 'rgba(145, 170, 173, 1)',
    color_accent_loading_secondary_bg_100: 'rgba(255, 255, 255, 0)',
    color_accent_loading_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_loading_secondary_border_100: 'rgba(19, 26, 35, 1)',
    color_accent_loading_secondary_border_50: 'rgba(19, 26, 35, 1)',
    color_accent_loading_secondary_icon_100: 'rgba(19, 26, 35, 1)',
    color_accent_loading_secondary_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_loading_tertiary_bg_100: 'rgba(2, 76, 110, 1)',
    color_accent_loading_tertiary_bg_50: 'rgba(2, 76, 110, 1)',
    color_accent_loading_tertiary_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_optative_bg_50: 'rgba(68, 68, 68, 1)',
    color_accent_pressed_optative_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_optative_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_bg_100: 'rgba(246, 250, 251, 1)',
    color_accent_pressed_primary_bg_150: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_primary_bg_200: 'rgba(221, 250, 252, 1)',
    color_accent_pressed_primary_bg_50: 'rgba(255, 216, 20, 1)',
    color_accent_pressed_primary_border_50: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_primary_font_100: 'rgba(6, 113, 128, 1)',
    color_accent_pressed_primary_font_150: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_font_50: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_primary_icon_100: 'rgba(6, 113, 128, 1)',
    color_accent_pressed_primary_icon_150: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_icon_200: 'rgba(145, 170, 173, 1)',
    color_accent_pressed_primary_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_bg_100: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_secondary_border_100: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_border_50: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_font_100: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_font_150: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_font_200: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_font_250: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_font_50: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_icon_100: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_icon_150: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_icon_200: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_icon_250: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_secondary_icon_50: 'rgba(19, 26, 35, 1)',
    color_accent_pressed_tertiary_bg_100: 'rgba(2, 76, 110, 1)',
    color_accent_pressed_tertiary_bg_50: 'rgba(2, 76, 110, 1)',
    color_accent_pressed_tertiary_font_100: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_tertiary_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_tertiary_icon_100: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_tertiary_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_selected_bg_100: 'rgba(6, 113, 128, 1)',
    color_accent_selected_bg_150: 'rgba(221, 250, 252, 1)',
    color_accent_selected_bg_50: 'rgba(6, 113, 128, 1)',
    color_accent_selected_border_50: 'rgba(6, 113, 128, 1)',
    color_accent_selected_icon_50: 'rgba(6, 113, 128, 1)',
    color_accent_selected_onselected_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_selected_onselected_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_unselected_bg_50: 'rgba(246, 250, 251, 1)',
    color_accent_unselected_onunselected_font_50: 'rgba(43, 49, 63, 1)',
    color_accent_unselected_onunselected_icon_50: 'rgba(43, 49, 63, 1)',
    color_animation_bg_100: 'rgba(255, 153, 0, 1)',
    color_animation_bg_50: 'rgba(255, 216, 20, 1)',
    color_brand_bg_100: 'rgba(43, 49, 63, 1)',
    color_brand_bg_150: 'rgba(43, 49, 63, 1)',
    color_brand_bg_200: 'rgba(43, 49, 63, 1)',
    color_brand_bg_250: 'rgba(43, 49, 63, 1)',
    color_brand_bg_50: 'rgba(43, 49, 63, 1)',
    color_brand_border_50: 'rgba(43, 49, 63, 1)',
    color_brand_font_150: 'rgba(43, 49, 63, 1)',
    color_brand_font_50: 'rgba(43, 49, 63, 1)',
    color_brand_icon_100: 'rgba(43, 49, 63, 1)',
    color_brand_icon_50: 'rgba(43, 49, 63, 1)',
    color_category_atm_bg_100: 'rgba(230, 247, 249, 1)',
    color_category_atm_bg_50: 'rgba(52, 209, 229, 1)',
    color_category_atm_border_25: 'rgba(52, 209, 229, 1)',
    color_category_atm_icon_25: 'rgba(52, 209, 229, 1)',
    color_category_education_and_health_bg_100: 'rgba(224, 250, 240, 1)',
    color_category_education_and_health_bg_50: 'rgba(0, 202, 125, 1)',
    color_category_education_and_health_border_25: 'rgba(0, 202, 125, 1)',
    color_category_education_and_health_icon_25: 'rgba(0, 202, 125, 1)',
    color_category_excluded_transactions_bg_100: 'rgba(239, 244, 246, 1)',
    color_category_excluded_transactions_bg_50: 'rgba(96, 125, 139, 1)',
    color_category_excluded_transactions_border_25: 'rgba(96, 125, 139, 1)',
    color_category_excluded_transactions_icon_25: 'rgba(96, 125, 139, 1)',
    color_category_expense_bg_100: 'rgba(253, 241, 216, 1)',
    color_category_expense_bg_150: 'rgba(254, 244, 217, 1)',
    color_category_expense_bg_50: 'rgba(211, 145, 7, 1)',
    color_category_expense_border_25: 'rgba(211, 145, 7, 1)',
    color_category_expense_icon_25: 'rgba(211, 145, 7, 1)',
    color_category_home_bg_100: 'rgba(216, 246, 231, 1)',
    color_category_home_bg_50: 'rgba(27, 127, 79, 1)',
    color_category_home_border_25: 'rgba(27, 127, 79, 1)',
    color_category_home_icon_25: 'rgba(27, 127, 79, 1)',
    color_category_income_bg_100: 'rgba(230, 255, 227, 1)',
    color_category_income_bg_150: 'rgba(208, 236, 208, 1)',
    color_category_income_bg_50: 'rgba(25, 207, 0, 1)',
    color_category_income_border_25: 'rgba(25, 207, 0, 1)',
    color_category_income_icon_25: 'rgba(25, 207, 0, 1)',
    color_category_investments_and_savings_bg_100: 'rgba(211, 239, 242, 1)',
    color_category_investments_and_savings_bg_50: 'rgba(7, 120, 135, 1)',
    color_category_investments_and_savings_border_25: 'rgba(7, 120, 135, 1)',
    color_category_investments_and_savings_icon_25: 'rgba(7, 120, 135, 1)',
    color_category_leisure_and_travel_bg_100: 'rgba(251, 224, 238, 1)',
    color_category_leisure_and_travel_bg_50: 'rgba(255, 0, 132, 1)',
    color_category_leisure_and_travel_border_25: 'rgba(255, 0, 132, 1)',
    color_category_leisure_and_travel_icon_25: 'rgba(255, 0, 132, 1)',
    color_category_organizations_and_ong_bg_100: 'rgba(250, 233, 229, 1)',
    color_category_organizations_and_ong_bg_50: 'rgba(197, 96, 72, 1)',
    color_category_organizations_and_ong_border_25: 'rgba(197, 96, 72, 1)',
    color_category_organizations_and_ong_icon_25: 'rgba(197, 96, 72, 1)',
    color_category_other_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_other_bg_50: 'rgba(95, 121, 125, 1)',
    color_category_other_border_25: 'rgba(19, 26, 35, 1)',
    color_category_other_icon_25: 'rgba(19, 26, 35, 1)',
    color_category_profesional_expenses_bg_100: 'rgba(220, 245, 215, 1)',
    color_category_profesional_expenses_bg_50: 'rgba(29, 151, 4, 1)',
    color_category_profesional_expenses_border_25: 'rgba(29, 151, 4, 1)',
    color_category_profesional_expenses_icon_25: 'rgba(29, 151, 4, 1)',
    color_category_restaurants_bg_100: 'rgba(254, 231, 223, 1)',
    color_category_restaurants_bg_50: 'rgba(236, 83, 27, 1)',
    color_category_restaurants_border_25: 'rgba(236, 83, 27, 1)',
    color_category_restaurants_icon_25: 'rgba(236, 83, 27, 1)',
    color_category_shopping_bg_100: 'rgba(255, 250, 204, 1)',
    color_category_shopping_bg_50: 'rgba(228, 181, 22, 1)',
    color_category_shopping_border_25: 'rgba(228, 181, 22, 1)',
    color_category_shopping_icon_25: 'rgba(228, 181, 22, 1)',
    color_category_transfer_bg_100: 'rgba(221, 240, 247, 1)',
    color_category_transfer_bg_50: 'rgba(10, 137, 187, 1)',
    color_category_transfer_border_25: 'rgba(10, 137, 187, 1)',
    color_category_transfer_icon_25: 'rgba(10, 137, 187, 1)',
    color_category_transport_bg_100: 'rgba(241, 252, 212, 1)',
    color_category_transport_bg_50: 'rgba(137, 175, 41, 1)',
    color_category_transport_border_25: 'rgba(137, 175, 41, 1)',
    color_category_transport_icon_25: 'rgba(137, 175, 41, 1)',
    color_chart_bg_100: 'rgba(135, 18, 57, 1)',
    color_chart_bg_150: 'rgba(177, 81, 102, 1)',
    color_chart_bg_200: 'rgba(76, 84, 164, 1)',
    color_chart_bg_250: 'rgba(122, 133, 237, 1)',
    color_chart_bg_300: 'rgba(58, 97, 139, 1)',
    color_chart_bg_325: 'rgba(255, 255, 255, 0)',
    color_chart_bg_350: 'rgba(88, 120, 155, 1)',
    color_chart_bg_400: 'rgba(18, 135, 43, 1)',
    color_chart_bg_450: 'rgba(6, 113, 128, 1)',
    color_chart_bg_50: 'rgba(204, 26, 26, 1)',
    color_chart_bg_500: 'rgba(132, 119, 1, 1)',
    color_chart_bg_525: 'rgba(255, 255, 255, 0)',
    color_chart_bg_550: 'rgba(209, 114, 24, 1)',
    color_chart_bg_600: 'rgba(169, 89, 13, 1)',
    color_chart_bg_700: 'rgba(209, 114, 24, 1)',
    color_chart_bg_800: 'rgba(209, 114, 24, 1)',
    color_chart_bg_opacity_100: 'rgba(135, 18, 57, 0.24705882352941178)',
    color_chart_bg_opacity_150: 'rgba(248, 136, 136, 0.24705882352941178)',
    color_chart_bg_opacity_200: 'rgba(103, 58, 183, 0.24705882352941178)',
    color_chart_bg_opacity_250: 'rgba(76, 84, 164, 0.24705882352941178)',
    color_chart_bg_opacity_300: 'rgba(122, 237, 224, 0.24705882352941178)',
    color_chart_bg_opacity_325: 'rgba(58, 97, 139, 0.24705882352941178)',
    color_chart_bg_opacity_350: 'rgba(96, 183, 194, 0.24705882352941178)',
    color_chart_bg_opacity_400: '#3F12872B',
    color_chart_bg_opacity_450: 'rgba(199, 188, 25, 0.24705882352941178)',
    color_chart_bg_opacity_50: 'rgba(204, 26, 26, 0.24705882352941178)',
    color_chart_bg_opacity_500: 'rgba(132, 119, 1, 0.24705882352941178)',
    color_chart_bg_opacity_525: 'rgba(255, 153, 0, 0.24705882352941178)',
    color_chart_bg_opacity_550: 'rgba(209, 114, 24, 0.24705882352941178)',
    color_chart_bg_opacity_600: 'rgba(169, 89, 13, 0.24705882352941178)',
    color_chart_bg_opacity_700: 'rgba(255, 255, 255, 0.4980392156862745)',
    color_comp_actions_button_primary_default_bgcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_button_primary_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_button_primary_default_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_button_primary_hover_bgcolor: 'rgba(255, 231, 114, 1)',
    color_comp_actions_button_primary_hover_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_button_primary_hover_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_button_primary_pressed_bgcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_button_primary_pressed_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_button_primary_pressed_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_closebutton_primary_default_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_closebutton_secondary_default_bgcolor: 'rgba(255, 255, 255, 1)',
    color_comp_actions_closebutton_secondary_default_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_inverse_default_iconcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_iconbutton_inverse_hover_iconcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_iconbutton_inverse_pressed_iconcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_iconbutton_primary_default_iconcolor: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbutton_primary_hover_iconcolor: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbutton_primary_pressed_iconcolor: 'rgba(145, 170, 173, 1)',
    color_comp_actions_iconbutton_primaryfilled_default_bgcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_iconbutton_primaryfilled_default_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_primaryfilled_hover_bgcolor: 'rgba(255, 231, 114, 1)',
    color_comp_actions_iconbutton_primaryfilled_hover_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_primaryfilled_pressed_bgcolor: 'rgba(255, 216, 20, 1)',
    color_comp_actions_iconbutton_primaryfilled_pressed_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondary_default_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondary_hover_iconcolor: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondary_pressed_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondaryfilled_default_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_actions_iconbutton_secondaryfilled_default_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondaryfilled_default_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondaryfilled_hover_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_actions_iconbutton_secondaryfilled_hover_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondaryfilled_hover_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondaryfilled_pressed_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_actions_iconbutton_secondaryfilled_pressed_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_iconbutton_secondaryfilled_pressed_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_image_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_initials_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_initials_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_with_tag_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_with_tag_initials_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_with_tag_initials_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_primary_with_tag_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_secondary_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_secondary_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_secondary_with_tag_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_secondary_with_tag_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_tertiary_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_tertiary_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_tertiary_with_tag_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_actions_quickbutton_tertiary_with_tag_on_page_default_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_checkbox_selected_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_forms_checkbox_unselected_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_forms_chip_bgcolor: 'rgba(246, 250, 251, 1)',
    color_comp_forms_chip_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_draggableitem_default_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_forms_draggableitem_draggable_bgcolor: 'rgba(255, 255, 255, 1)',
    color_comp_forms_draggableitem_draggable_iconcolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_draggableitem_pressed_bgcolor: 'rgba(246, 250, 251, 1)',
    color_comp_forms_fileuploader_bgcolor: 'rgba(255, 255, 255, 1)',
    color_comp_forms_fileuploader_bordercolor: 'rgba(187, 202, 205, 1)',
    color_comp_forms_fileuploader_iconcolor: 'rgba(43, 49, 63, 1)',
    color_comp_forms_fileuploader_loadingcontainer_bordercolor: 'rgba(43, 49, 63, 1)',
    color_comp_forms_input_active_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_input_bgcolor: 'rgba(255, 255, 255, 1)',
    color_comp_forms_input_bgcolorprefixsufix: 'rgba(221, 229, 231, 1)',
    color_comp_forms_input_filled_textcolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_input_secondarytextcolor: 'rgba(95, 121, 125, 1)',
    color_comp_forms_pill_selected_bgcolor: 'rgba(6, 113, 128, 1)',
    color_comp_forms_pill_selected_bordercolor: 'rgba(6, 113, 128, 1)',
    color_comp_forms_pill_selected_iconcolor: 'rgba(255, 255, 255, 1)',
    color_comp_forms_pill_unselected_bgcolor: 'rgba(246, 250, 251, 1)',
    color_comp_forms_pill_unselected_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_pill_unselected_iconcolor: 'rgba(43, 49, 63, 1)',
    color_comp_forms_toggle_selected_thumb_bgcolor: 'rgba(255, 255, 255, 1)',
    color_comp_forms_toggle_unselected_bgcolor: 'rgba(19, 26, 35, 1)',
    color_comp_forms_toggle_unselected_thumb_bgcolor: 'rgba(255, 255, 255, 1)',
    color_comp_resources_avatarprofile_empty_default_bordercolor: 'rgba(19, 26, 35, 1)',
    color_comp_resources_avatarprofile_image_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_resources_avatarprofile_initials_bgcolor: 'rgba(246, 250, 251, 1)',
    color_comp_resources_avatarprofile_initials_default_bordercolor: 'rgba(95, 121, 125, 1)',
    color_comp_resources_avatarprofile_initials_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_resources_avatarprofile_isotype_bgcolor: 'rgba(255, 255, 255, 0)',
    color_comp_resources_dot_bgcolor: 'rgba(204, 26, 26, 1)',
    color_comp_resources_dot_bordercolor: 'rgba(255, 255, 255, 1)',
    color_comp_resources_dot_fontcolor: 'rgba(255, 255, 255, 1)',
    color_comp_resources_iconhighlighted_bgcolor: 'rgba(246, 250, 251, 1)',
    color_comp_resources_selectionindicator_default_selected_iconcolor: 'rgba(255, 255, 255, 1)',
    color_comp_status_progressbarchart_empty_bgcolor: 'rgba(221, 229, 231, 1)',
    color_comp_status_progressbarchart_filled_bgcolor: 'rgba(209, 114, 24, 1)',
    color_comp_status_progressbarlinear_fontcolor: 'rgba(19, 26, 35, 1)',
    color_comp_status_progressbarlinear_regular_empty_bgcolor: 'rgba(221, 229, 231, 1)',
    color_comp_status_progressbarsegmented_elements_empty_bgcolor: 'rgba(221, 229, 231, 1)',
    color_comp_status_progressbarsegmented_elements_filled_bgcolor: 'rgba(209, 114, 24, 1)',
    color_comp_status_skeleton_onsurface_bgcolor: 'rgba(187, 202, 205, 1)',
    color_comp_status_skeleton_regular_bgcolor: 'rgba(246, 250, 251, 1)',
    color_comp_tag_neutral_bgcolor: 'rgba(95, 121, 125, 1)',
    color_contact_center_accent_active_primary_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_default_primary_bg_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_default_primary_font_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_default_primary_icon_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_default_secondary_bg_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_default_secondary_border_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_disabled_bg_100: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_disabled_border_100: 'rgba(187, 202, 205, 1)',
    color_contact_center_accent_disabled_font_100: 'rgba(187, 202, 205, 1)',
    color_contact_center_accent_disabled_font_50: 'rgba(95, 121, 125, 1)',
    color_contact_center_accent_disabled_icon_100: 'rgba(187, 202, 205, 1)',
    color_contact_center_accent_disabled_icon_50: 'rgba(95, 121, 125, 1)',
    color_contact_center_accent_hover_primary_bg_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_hover_primary_font_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_hover_primary_icon_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_hover_secondary_bg_50: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_hover_secondary_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_loading_primary_bg_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_loading_secondary_bg_50: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_loading_secondary_border_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_loading_secondary_icon_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_ondefault_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_ondefault_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_ondefault_secondary_font_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_ondefault_secondary_icon_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_onhover_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onhover_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onhover_secondary_font_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_onhover_secondary_icon_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_onpressed_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onpressed_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onpressed_secondary_font_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_onpressed_secondary_icon_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_pressed_primary_bg_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_pressed_primary_font_50: 'rgba(52, 29, 92, 1)',
    color_contact_center_accent_pressed_primary_icon_50: 'rgba(52, 29, 92, 1)',
    color_contact_center_accent_pressed_secondary_bg_50: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_pressed_secondary_border_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_exception_feedback_error_bg_100: 'rgba(255, 255, 255, 1)',
    color_contact_center_exception_feedback_error_bg_200: 'rgba(255, 255, 255, 1)',
    color_contact_center_feedback_error_bg_300: 'rgba(254, 238, 233, 1)',
    color_contact_center_feedback_error_border_50: 'rgba(159, 0, 0, 1)',
    color_contact_center_feedback_error_font_50: 'rgba(159, 0, 0, 1)',
    color_contact_center_feedback_error_icon_50: 'rgba(159, 0, 0, 1)',
    color_contact_center_feedback_info_bg_50: 'rgba(240, 235, 248, 1)',
    color_contact_center_feedback_info_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_bg_100: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_bg_50: 'rgba(240, 235, 248, 1)',
    color_contact_center_neutral_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_font_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_icon_50: 'rgba(82, 46, 146, 1)',
    color_effect_focus_100: 'rgba(209, 114, 24, 1)',
    color_effect_focus_50: 'rgba(255, 255, 255, 1)',
    color_effect_shadow_drop_100: 'rgba(19, 26, 35, 0.24705882352941178)',
    color_effect_shadow_drop_150: 'rgba(255, 255, 255, 0)',
    color_effect_shadow_drop_50: 'rgba(19, 26, 35, 0.24705882352941178)',
    color_effect_shadow_drop_75: 'rgba(19, 26, 35, 0.14901960784313725)',
    color_effect_shadow_inner_50: 'rgba(19, 26, 35, 0.24705882352941178)',
    color_exception_accent_default_bg_100: 'rgba(204, 26, 26, 1)',
    color_exception_accent_default_bg_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_default_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_default_secondary_font_200: 'rgba(19, 26, 35, 1)',
    color_exception_accent_default_secondary_font_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_default_secondary_icon_100: 'rgba(19, 26, 35, 1)',
    color_exception_accent_default_secondary_icon_125: 'rgba(19, 26, 35, 1)',
    color_exception_accent_default_secondary_icon_200: 'rgba(19, 26, 35, 1)',
    color_exception_accent_default_secondary_icon_250: 'rgba(255, 216, 20, 1)',
    color_exception_accent_default_tertiary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_default_tertiary_border_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_disabled_bg_50: 'rgba(221, 229, 231, 1)',
    color_exception_accent_disabled_font_50: 'rgba(84, 102, 109, 1)',
    color_exception_accent_disabled_icon_50: 'rgba(84, 102, 109, 1)',
    color_exception_accent_hover_bg_50: 'rgba(246, 250, 251, 1)',
    color_exception_accent_hover_secondary_bg_100_onsurface: 'rgba(255, 255, 255, 0)',
    color_exception_accent_hover_secondary_bg_quickbutton_secondary: 'rgba(255, 255, 255, 0)',
    color_exception_accent_hover_secondary_border_100_onsurface_red: 'rgba(95, 121, 125, 1)',
    color_exception_accent_hover_secondary_font_100_onsurface: 'rgba(19, 26, 35, 1)',
    color_exception_accent_hover_secondary_font_150_onsurface_red: 'rgba(95, 121, 125, 1)',
    color_exception_accent_hover_secondary_icon_100_onsurface: 'rgba(19, 26, 35, 1)',
    color_exception_accent_hover_secondary_icon_150_onsurface_red: 'rgba(95, 121, 125, 1)',
    color_exception_accent_icon_100: 'rgba(19, 26, 35, 1)',
    color_exception_accent_icon_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_loading_primary_icon_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_loading_secondary_bg_150: 'rgba(31, 127, 141, 1)',
    color_exception_accent_loading_secondary_bg_50: 'rgba(43, 49, 63, 1)',
    color_exception_accent_loading_secondary_border_50: 'rgba(43, 49, 63, 1)',
    color_exception_accent_loading_secondary_icon_150: 'rgba(255, 255, 255, 1)',
    color_exception_accent_pressed_primary_icon_100: 'rgba(255, 255, 255, 1)',
    color_exception_accent_pressed_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_pressed_secondary_icon_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_pressed_tertiary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_pressed_tertiary_border_50: 'rgba(19, 26, 35, 1)',
    color_exception_accent_selected_bg_100: 'rgba(6, 113, 128, 0.14901960784313725)',
    color_exception_accent_selected_bg_50: 'rgba(255, 255, 255, 1)',
    color_exception_accent_selected_border_100: 'rgba(204, 26, 26, 1)',
    color_exception_accent_selected_border_50: 'rgba(255, 255, 255, 0)',
    color_exception_brand_bg_50: 'rgba(255, 153, 0, 1)',
    color_exception_brand_icon_100: 'rgba(19, 26, 35, 1)',
    color_exception_brand_icon_50: 'rgba(43, 49, 63, 1)',
    color_exception_feedback_error_bg_350: 'rgba(254, 238, 233, 1)',
    color_exception_feedback_error_bg_400: 'rgba(254, 238, 233, 1)',
    color_exception_feedback_error_icon_50: 'rgba(159, 0, 0, 1)',
    color_exception_feedback_success_bg_200: 'rgba(236, 255, 240, 1)',
    color_exception_feedback_success_bg_250: 'rgba(236, 255, 240, 1)',
    color_exception_neutral_bg_1000: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_1100: 'rgba(254, 238, 233, 1)',
    color_exception_neutral_bg_1200: 'rgba(221, 250, 252, 1)',
    color_exception_neutral_bg_1300: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_bg_1350: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_1400: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_700: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_bg_750: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_825: 'rgba(221, 229, 231, 1)',
    color_exception_neutral_bg_850: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_bg_875: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_bg_900: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_950: 'rgba(221, 229, 231, 1)',
    color_exception_neutral_border_100: 'rgba(95, 121, 125, 1)',
    color_exception_neutral_border_150: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_border_200: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_border_50: 'rgba(255, 255, 255, 0)',
    color_exception_neutral_border_onsurface_50: 'rgba(187, 202, 205, 1)',
    color_exception_neutral_border_onsurface_75: 'rgba(95, 121, 125, 1)',
    color_exception_neutral_font_350: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_font_375: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_font_400: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_font_450: 'rgba(10, 89, 101, 1)',
    color_exception_neutral_icon_350: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_icon_400: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_icon_450: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_icon_500: 'rgba(19, 26, 35, 1)',
    color_exception_neutral_icon_550: 'rgba(255, 153, 0, 1)',
    color_exception_neutral_icon_600: 'rgba(255, 153, 0, 1)',
    color_exception_product_icon_50: 'rgba(43, 49, 63, 1)',
    color_exception_secondary_bg_100: 'rgba(10, 89, 101, 1)',
    color_exception_secondary_bg_150: 'rgba(10, 89, 101, 1)',
    color_exception_secondary_bg_50: 'rgba(204, 26, 26, 1)',
    color_exception_secondary_bg_550: 'rgba(246, 250, 251, 1)',
    color_exception_secondary_border_50: 'rgba(255, 255, 255, 1)',
    color_exception_secondary_font_50: 'rgba(255, 255, 255, 1)',
    color_exception_secondary_icon_50: 'rgba(10, 89, 101, 1)',
    color_feedback_error_bg_100: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_200: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_300: 'rgba(254, 238, 233, 1)',
    color_feedback_error_bg_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_bg_75: 'rgba(159, 0, 0, 1)',
    color_feedback_error_bg_mainsection_100: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_mainsection_50: 'rgba(255, 255, 255, 1)',
    color_feedback_error_border_100: 'rgba(159, 0, 0, 1)',
    color_feedback_error_border_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_border_75: 'rgba(159, 0, 0, 1)',
    color_feedback_error_border_mainsection_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_100: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_mainsection_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_onsurface_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_icon_100: 'rgba(159, 0, 0, 1)',
    color_feedback_error_icon_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_icon_onsurface_50: 'rgba(159, 0, 0, 1)',
    color_feedback_info_bg_100: 'rgba(10, 89, 101, 1)',
    color_feedback_info_bg_150: 'rgba(221, 250, 252, 1)',
    color_feedback_info_bg_50: 'rgba(6, 113, 128, 1)',
    color_feedback_info_border_100: 'rgba(10, 89, 101, 1)',
    color_feedback_info_border_150: 'rgba(10, 89, 101, 1)',
    color_feedback_info_border_50: 'rgba(10, 89, 101, 1)',
    color_feedback_info_border_75: 'rgba(4, 152, 220, 1)',
    color_feedback_info_font_50: 'rgba(10, 89, 101, 1)',
    color_feedback_info_icon_50: 'rgba(10, 89, 101, 1)',
    color_feedback_status_bg_50: 'rgba(122, 133, 237, 1)',
    color_feedback_success_bg_100: 'rgba(18, 135, 43, 1)',
    color_feedback_success_bg_150: 'rgba(236, 255, 240, 1)',
    color_feedback_success_bg_50: 'rgba(76, 192, 101, 1)',
    color_feedback_success_border_100: 'rgba(18, 135, 43, 1)',
    color_feedback_success_border_50: 'rgba(18, 135, 43, 1)',
    color_feedback_success_border_75: 'rgba(19, 146, 19, 1)',
    color_feedback_success_font_425: 'rgba(76, 192, 101, 1)',
    color_feedback_success_font_50: 'rgba(18, 135, 43, 1)',
    color_feedback_success_icon_50: 'rgba(18, 135, 43, 1)',
    color_feedback_success_icon_75: 'rgba(18, 135, 43, 1)',
    color_feedback_warning_bg_100: 'rgba(209, 114, 24, 1)',
    color_feedback_warning_bg_150: 'rgba(255, 242, 228, 1)',
    color_feedback_warning_bg_50: 'rgba(242, 161, 84, 1)',
    color_feedback_warning_border_100: 'rgba(209, 114, 24, 1)',
    color_feedback_warning_border_50: 'rgba(209, 114, 24, 1)',
    color_feedback_warning_border_75: 'rgba(227, 182, 58, 1)',
    color_feedback_warning_font_50: 'rgba(209, 114, 24, 1)',
    color_feedback_warning_icon_50: 'rgba(209, 114, 24, 1)',
    color_neutral_alt_font_50: 'rgba(204, 204, 204, 1)',
    color_neutral_bg_100: 'rgba(68, 68, 68, 1)',
    color_neutral_bg_150: 'rgba(102, 102, 102, 1)',
    color_neutral_bg_200: 'rgba(148, 148, 148, 1)',
    color_neutral_bg_250: 'rgba(204, 204, 204, 1)',
    color_neutral_bg_275: 'rgba(245, 245, 245, 1)',
    color_neutral_bg_300: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_325: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_350: 'rgba(43, 49, 63, 1)',
    color_neutral_bg_375: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_400: 'rgba(255, 255, 255, 0)',
    color_neutral_bg_450: 'rgba(19, 26, 35, 1)',
    color_neutral_bg_50: 'rgba(19, 26, 35, 1)',
    color_neutral_bg_500: 'rgba(95, 121, 125, 1)',
    color_neutral_bg_550: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_600: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_650: 'rgba(95, 121, 125, 1)',
    color_neutral_bg_75: 'rgba(102, 102, 102, 1)',
    color_neutral_bg_800: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_mainsection_50: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_onsurface_100: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_onsurface_150: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_onsurface_200: 'rgba(255, 255, 255, 0)',
    color_neutral_bg_onsurface_50: 'rgba(19, 26, 35, 1)',
    color_neutral_bg_onsurface_55: 'rgba(95, 121, 125, 1)',
    color_neutral_bg_onsurface_65: 'rgba(187, 202, 205, 1)',
    color_neutral_bg_skeleton_100: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_skeleton_50: 'rgba(187, 202, 205, 1)',
    color_neutral_bg_static_100: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_static_50: 'rgba(19, 26, 35, 1)',
    color_neutral_bg_static_75: 'rgba(187, 202, 205, 1)',
    color_neutral_border_100: 'rgba(68, 68, 68, 1)',
    color_neutral_border_150: 'rgba(19, 26, 35, 1)',
    color_neutral_border_160: 'rgba(187, 202, 205, 1)',
    color_neutral_border_175: 'rgba(245, 245, 245, 1)',
    color_neutral_border_200: 'rgba(255, 255, 255, 1)',
    color_neutral_border_250: 'rgba(255, 255, 255, 0)',
    color_neutral_border_300: 'rgba(255, 255, 255, 1)',
    color_neutral_border_350: 'rgba(187, 202, 205, 1)',
    color_neutral_border_355: 'rgba(187, 202, 205, 1)',
    color_neutral_border_50: 'rgba(19, 26, 35, 1)',
    color_neutral_border_800: 'rgba(255, 255, 255, 1)',
    color_neutral_border_mainsection_100: 'rgba(19, 26, 35, 1)',
    color_neutral_border_mainsection_50: 'rgba(19, 26, 35, 1)',
    color_neutral_border_onsurface_100: 'rgba(95, 121, 125, 1)',
    color_neutral_border_onsurface_150: 'rgba(19, 26, 35, 1)',
    color_neutral_border_onsurface_50: 'rgba(102, 102, 102, 1)',
    color_neutral_border_static_50: 'rgba(255, 255, 255, 1)',
    color_neutral_font_100: 'rgba(95, 121, 125, 1)',
    color_neutral_font_150: 'rgba(95, 121, 125, 1)',
    color_neutral_font_200: 'rgba(255, 255, 255, 1)',
    color_neutral_font_250: 'rgba(255, 255, 255, 1)',
    color_neutral_font_300: 'rgba(255, 255, 255, 1)',
    color_neutral_font_350: 'rgba(19, 26, 35, 1)',
    color_neutral_font_50: 'rgba(19, 26, 35, 1)',
    color_neutral_font_mainsection_50: 'rgba(95, 121, 125, 1)',
    color_neutral_font_onsurface_100: 'rgba(255, 255, 255, 1)',
    color_neutral_font_onsurface_200: 'rgba(95, 121, 125, 1)',
    color_neutral_font_onsurface_50: 'rgba(19, 26, 35, 1)',
    color_neutral_icon_100: 'rgba(68, 68, 68, 1)',
    color_neutral_icon_150: 'rgba(95, 121, 125, 1)',
    color_neutral_icon_175: 'rgba(204, 204, 204, 1)',
    color_neutral_icon_200: 'rgba(255, 255, 255, 1)',
    color_neutral_icon_250: 'rgba(255, 255, 255, 1)',
    color_neutral_icon_300: 'rgba(19, 26, 35, 1)',
    color_neutral_icon_50: 'rgba(19, 26, 35, 1)',
    color_neutral_icon_mainsection_50: 'rgba(19, 26, 35, 1)',
    color_neutral_icon_onsurface_100: 'rgba(255, 255, 255, 1)',
    color_neutral_icon_onsurface_50: 'rgba(19, 26, 35, 1)',
    color_neutral_screen_bg_100: 'rgba(245, 245, 245, 1)',
    color_neutral_screen_bg_1000: 'rgba(245, 245, 245, 1)',
    color_neutral_screen_bg_1050: 'rgba(245, 245, 245, 1)',
    color_neutral_screen_bg_150: 'rgba(246, 250, 251, 1)',
    color_neutral_screen_bg_175: 'rgba(255, 255, 255, 1)',
    color_neutral_screen_bg_200: 'rgba(245, 245, 245, 1)',
    color_neutral_screen_bg_250: 'rgba(255, 255, 255, 1)',
    color_neutral_screen_bg_275: 'rgba(17, 17, 17, 1)',
    color_neutral_screen_bg_300: 'rgba(208, 236, 208, 1)',
    color_neutral_screen_bg_350: 'rgba(254, 244, 217, 1)',
    color_neutral_screen_bg_400: 'rgba(204, 204, 204, 1)',
    color_neutral_screen_bg_450: 'rgba(246, 250, 251, 1)',
    color_neutral_screen_bg_475: 'rgba(246, 250, 251, 1)',
    color_neutral_screen_bg_50: 'rgba(221, 229, 231, 1)',
    color_neutral_screen_bg_500: 'rgba(255, 232, 220, 1)',
    color_neutral_screen_bg_550: 'rgba(235, 212, 239, 1)',
    color_neutral_screen_bg_600: 'rgba(225, 216, 241, 1)',
    color_neutral_screen_bg_650: 'rgba(226, 239, 233, 1)',
    color_neutral_screen_bg_700: 'rgba(246, 241, 234, 1)',
    color_neutral_screen_bg_750: 'rgba(246, 247, 232, 1)',
    color_neutral_screen_bg_800: 'rgba(247, 210, 243, 1)',
    color_neutral_screen_bg_850: 'rgba(248, 212, 227, 1)',
    color_neutral_screen_bg_900: 'rgba(230, 246, 254, 1)',
    color_neutral_screen_bg_950: 'rgba(245, 245, 245, 1)',
    color_neutral_screen_bg_wealth_50: 'rgba(255, 255, 255, 0)',
    color_product_accounts_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_accounts_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_accounts_icon_400: 'rgba(43, 49, 63, 1)',
    color_product_cards_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_cards_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_deposits_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_deposits_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_deposits_icon_400: 'rgba(43, 49, 63, 1)',
    color_product_insurance_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_insurance_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_loans_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_loans_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_loans_icon_400: 'rgba(43, 49, 63, 1)',
    color_product_mortgages_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_mortgages_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_wealth_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_wealth_bg_50: 'rgba(246, 250, 251, 1)',
    color_secondary_bg_100: 'rgba(43, 49, 63, 1)',
    color_secondary_bg_150: 'rgba(221, 250, 252, 1)',
    color_secondary_bg_200: 'rgba(43, 49, 63, 1)',
    color_secondary_bg_250: 'rgba(43, 49, 63, 1)',
    color_secondary_bg_400: 'rgba(43, 49, 63, 1)',
    color_secondary_bg_450: 'rgba(43, 49, 63, 1)',
    color_secondary_bg_475: 'rgba(43, 49, 63, 1)',
    color_secondary_bg_50: 'rgba(204, 26, 26, 1)',
    color_secondary_bg_500: 'rgba(221, 250, 252, 1)',
    color_secondary_bg_550: 'rgba(230, 246, 254, 1)',
    color_secondary_border_100: 'rgba(5, 56, 64, 1)',
    color_secondary_border_200: 'rgba(43, 49, 63, 1)',
    color_secondary_border_50: 'rgba(43, 49, 63, 1)',
    color_secondary_border_mainsection_100: 'rgba(5, 56, 64, 1)',
    color_secondary_icon_100: 'rgba(43, 49, 63, 1)',
    color_secondary_icon_150: 'rgba(43, 49, 63, 1)',
    color_secondary_icon_200: 'rgba(43, 49, 63, 1)',
    color_secondary_icon_350: 'rgba(43, 49, 63, 1)',
    color_secondary_icon_400: 'rgba(43, 49, 63, 1)',
    color_secondary_icon_450: 'rgba(43, 49, 63, 1)',
    color_secondary_icon_50: 'rgba(43, 49, 63, 1)',
};
export { RegularCobrandedKubitColorsFoundationsTheming };
//# sourceMappingURL=regular-cobranded-kubit-colors-foundations.theming.js.map